// extracted by mini-css-extract-plugin
export default {"delivery":"quantityIcon_delivery__nsK0I","many":"quantityIcon_many__YsHle","mean":"quantityIcon_mean__qvpw7","few":"quantityIcon_few__lQvds"};